export const socialClubActionTypes = {
  SET_CLUB_EVENT_DATA: 'SET_CLUB_EVENT_DATA',
  SET_CLUB_LIST: 'SET_CLUB_LIST',
  SET_CLUB_LIVE_DATA: 'SET_CLUB_LIVE_DATA',
  SET_CLUB_CLOSED_DATA: 'SET_CLUB_CLOSED_DATA',
  SET_CLUB_LIST_FAIL: 'SET_CLUB_LIST_FAIL',
  SET_CLUB_LIVE_DATA_FAIL: 'SET_CLUB_LIVE_DATA_FAIL',
  SET_CLUB_CLOSED_DATA_FAIL: 'SET_CLUB_CLOSED_DATA_FAIL',
  SET_CLUB_LIST_REQUEST: 'SET_CLUB_LIST_REQUEST',
  SET_CLUB_LIVE_DATA_REQUEST: 'SET_CLUB_LIVE_DATA_REQUEST',
  SET_CLUB_CLOSED_DATA_REQUEST: 'SET_CLUB_CLOSED_DATA_REQUEST',
  SET_CLUB_EVENT_DATA_FAIL: 'SET_CLUB_EVENT_DATA_FAIL',
  SET_CLUB_EVENT_DATA_LOAD: 'SET_CLUB_EVENT_DATA_LOAD',
  FETCH_CLUB_MARKET_REQUEST: 'FETCH_CLUB_MARKET_REQUEST',
  FETCH_CLUB_MARKET_SUCCESS: 'FETCH_CLUB_MARKET_SUCCESS',
  FETCH_CLUB_MARKET_ERROR: 'FETCH_CLUB_MARKET_ERROR',
};
